import { useFormikContext } from 'formik';

import { AUDIENCE_METADATA } from '../../metadata';
import { AsyncSelectValue } from './value-types/AsyncSelectValue';
import { CheckBoxValue } from './value-types/CheckBoxValue';
import { DurationValue } from './value-types/DurationValue';
import { MoneyValue } from './value-types/MoneyValue';
import { NumberValue } from './value-types/NumberValue';
import { RadioValue } from './value-types/RadioValue';
import { TextValue } from './value-types/TextValue';

export function Values({ index, innerIndex, mode, rowActions, valueActions }) {
  const { values } = useFormikContext();
  const condition = values.conditions[index];

  const metadata = AUDIENCE_METADATA[condition.criteria];
  const { type, extra } = metadata;

  switch (type) {
    case 'asyncSelect':
      return (
        <AsyncSelectValue
          index={index}
          innerIndex={innerIndex}
          mode={mode}
          rowActions={rowActions}
          valueActions={valueActions}
          extra={extra}
        />
      );
    case 'checkbox':
      return <CheckBoxValue index={index} innerIndex={innerIndex} />;
    case 'duration':
      return <DurationValue index={index} innerIndex={innerIndex} />;
    case 'money':
      return <MoneyValue index={index} innerIndex={innerIndex} />;
    case 'number':
      return <NumberValue index={index} innerIndex={innerIndex} />;
    case 'radio':
      return <RadioValue index={index} innerIndex={innerIndex} />;
    case 'url':
    case 'text':
      return (
        <TextValue
          index={index}
          innerIndex={innerIndex}
          rowActions={rowActions}
          valueActions={valueActions}
          extra={extra}
        />
      );
  }
}
